import { Row } from "../../grid";
import React from 'react';
import { ErrorMessage, Hint, ValidateErrorIcon } from '.';
var InputHintError = function (_a) {
    var error = _a.error, validation = _a.validation, hint = _a.hint;
    return error && validation ? (React.createElement(Row, { className: "InputHintError", alignItems: "center" },
        React.createElement(ValidateErrorIcon, null),
        React.createElement(ErrorMessage, null, error))) : (React.createElement(Hint, null, hint));
};
export default InputHintError;
//# sourceMappingURL=InputHintError.js.map